import { render, staticRenderFns } from "./YourPromoTable.vue?vue&type=template&id=1ccf1857"
import script from "./YourPromoTable.vue?vue&type=script&lang=js"
export * from "./YourPromoTable.vue?vue&type=script&lang=js"
import style0 from "./YourPromoTable.vue?vue&type=style&index=0&id=1ccf1857&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports